import { useSyncExternalStore } from 'react';
import { chatDraftStore, type DraftSummary } from '../services/chatDraftStore';

/**
 * Resumo reativo do rascunho de uma conversa (texto + mídia pendente).
 * Passe `undefined` para desativar (ex.: conversa atualmente aberta — o
 * rascunho já está visível no próprio composer; evita re-render por tecla).
 */
export const useConversationDraft = (conversationId: string | undefined): DraftSummary | null =>
  useSyncExternalStore(
    chatDraftStore.subscribe,
    () => (conversationId ? chatDraftStore.getDraftSummary(conversationId) : null),
  );
